export default "__VITE_ASSET__CtztUdV___"